module.exports = __webpack_public_path__ + "static/media/block-negative.686823f2.svg";